import ExclamationMarkIcon from '@/lib/assets/mark.svg';
import styles from './StoredPaymentMethod.module.scss';
import { useTranslation } from 'react-i18next';

const StoredPaymentMethod = () => {
    const { t } = useTranslation();
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <ExclamationMarkIcon className={styles.icon}/>
                <p>{t('storedPaymentMethod')}</p>
            </div>
            <div className={styles.text}>
                {t('storedPaymentMethodWarning')}
            </div>
        </div>
    );
};

export default StoredPaymentMethod;
